export const truncateText = (text: string | undefined, maxLength = 10): string => {
  if (!text) return '';
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

/**
 * We save orderEasyId, serviceType, deviceName and desiredTime in the chequeName when creating a parked order
 * This is because we don't want to pollute the tableApi because parked order is not really a real cheque
 */
export const parseParkedOrderName = (
  name: string,
): {
  orderEasyId: string | null;
  serviceType: string | null;
  deviceName: string | null;
  desiredTime: string | null;
  orderName: string;
} => {
  const regex = /^\[orderEasyId:(.*?),serviceType:(.*?),device:(.*?),desiredTime:(.*?)\]\s*(.*)$/;
  const match = name.match(regex);

  if (match) {
    const [, orderEasyId, serviceType, deviceName, desiredTime, orderName] = match;
    return {
      orderEasyId,
      serviceType,
      deviceName,
      desiredTime: desiredTime === 'null' ? null : desiredTime,
      orderName,
    };
  }

  // TODO: Remove this block after 22nd april
  // Check for old format without orderEasyId
  const oldRegex = /^\[serviceType:(.*?),device:(.*?),desiredTime:(.*?)\]\s*(.*)$/;
  const oldMatch = name.match(oldRegex);

  if (oldMatch) {
    const [, serviceType, deviceName, desiredTime, orderName] = oldMatch;
    return {
      orderEasyId: null,
      serviceType,
      deviceName,
      desiredTime: desiredTime === 'null' ? null : desiredTime,
      orderName,
    };
  }

  return {
    orderEasyId: null,
    serviceType: null,
    deviceName: null,
    desiredTime: null,
    orderName: name,
  };
};
